import React, { useEffect, useState } from "react";
import { properties } from "../../../config/properties";
import {useLocation, useNavigate} from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Container,
    Icon,
    Row,
    Table,
    Pager,
    PagerItem,
    Spinner,
    PagerLink, Dimmer, Label, Modal, Alert
} from "design-react-kit";

import SpinnerCustom from "../../layout/Spinner";

const styles = {

    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '90vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },


};
const ElencoPersone = ({user}) => {
    const location = useLocation();

    const { ricerca } = location.state || {};

    const initialLimit = 10;
    const initialOffset = 0;

    const [limit, setLimit] = useState(initialLimit);
    const [offset, setOffset] = useState(initialOffset);
    const [persone, setPersone] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [datiRicerca, setDatiRicerca] = useState(ricerca?.dati || {});

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    const [sortField, setSortField] = useState("cognome");
    const [sortDirection, setSortDirection] = useState("asc"); // default: decrescente

    const [personaToDelete, setPersonaToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [loadingUser, setLoadingUser] = useState(true);

    const navigate = useNavigate();

    const totalPages = Math.ceil(totalElements / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    const [isDownloading, setIsDownloading] = useState(false);


    useEffect(() => {
        if (datiRicerca) {
            getPersoneList({
                offset,
                limit,
                dati: datiRicerca,
                sortField,
                sortDirection,
                userID: user.userID,
                cciaa: user.cciaa,
                gruppoUtente:user.gruppoUtente
            });
        }
    }, [offset, limit, datiRicerca, sortField, sortDirection]);

    useEffect(() => {
        if (location.state?.esito) {
            setAlert({ visible: false, type: '', message: '' });
            window.scrollTo({top: 0, behavior: 'smooth'});
            const message = location.state.esito.messaggio;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({visible: true, type, message});
        }

    }, [location.state]);


    const handleSearch = (persona) => {
        const datiRicerca = {

            dati : {
                "id" : persona.id
            }
        };

        navigate('/private/profiloPersona', { state: { ricerca: datiRicerca ,  nomeProfilo : persona.nome , cognomeProfilo : persona.cognome} });
    };

    const handleEdit = (id) => {

        const idProfilo = {
            id : id
        };

        navigate('/private/modificaPersona', {state : { idProfilo : idProfilo }});

    }


    const handleSort = (field) => {
        if (sortField === field) {
            // Se clicco la stessa colonna, inverto l'ordine
            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDirection("asc"); // reset a asc se è una nuova colonna
        }
    };

    const openDeleteConfirm = (persona) => {
        setPersonaToDelete(persona);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setPersonaToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {

        setAlert({ visible: false, type: '', message: '' });
        if (!personaToDelete) return;


        try {
            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/persona`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: personaToDelete.id , userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            const json = await res.json();

            if (json.esito === "OK") {

                await getPersoneList({
                    offset,
                    limit,
                    dati: datiRicerca,
                    sortField,
                    sortDirection,
                    userID: user.userID,
                    cciaa: user.cciaa,
                    gruppoUtente:user.gruppoUtente
                });
                setAlert({ visible: true, type: 'success', message: json.messaggio });
                window.scrollTo({top: 0, behavior: 'smooth'});
            } else {
                setAlert({ visible: true, type: 'danger', message: json.messaggio});
                window.scrollTo({top: 0, behavior: 'smooth'});
            }
        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });
            window.scrollTo({top: 0, behavior: 'smooth'});
        } finally {
            closeDeleteConfirm();
        }
    };



    const getPersoneList = async (params) => {
        try {
            setAlert({ visible: false, type: '', message: '' });
            setLoadingUser(true);

            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getElencoPersone",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setPersone([]);
                setTotalElements(0);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!res.ok) throw new Error("Errore HTTP");

            const data = await res.json();

            setTotalElements(data.totalElements || 0);
            setPersone(data.content || []);

        } catch (e) {

            setAlert({ visible: true, type: 'danger', message: 'Errore di comunicazione con il server.' });

            setPersone([]);
            setTotalElements(0);

        }finally {
            setLoadingUser(false);
        }
    };

    const handleDownloadCsv = async () => {
        try {

            setAlert({ visible: false, type: '', message: '' });

            setIsDownloading(true);

            const response = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/getCsvPersone", // nuovo endpoint CSV
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            if (!response.ok) {
                throw new Error("Errore nel download del CSV");
            }

            const blob = await response.blob();
            const fileName = `Persone_${user.cciaa}.csv`;

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {

            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });

        }finally{
            setIsDownloading(false);
        }
    };


    const handleLimitChange = (newLimit) => {
        setLimit((prev) => {
            // React garantirà che il nuovo limit venga impostato prima del useEffect
            return newLimit;
        });
        setOffset(0); // questo causerà il useEffect a triggerarsi con offset 0 e nuovo limit
    };

    const handlePageChange = (page) => {
        const newOffset = (page - 1) * limit;
        setOffset(newOffset);
    };

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>


            </Container>
        );


    }

    const renderPagination = () => {
        const pages = [];

        let startInd =  (currentPage-1) > 0 ? currentPage-1 : 1
        let endInd =  (currentPage+1) < totalPages ? currentPage+1 : totalPages


        if(currentPage > 2){
            pages.push(
                <PagerItem
                    key={1}
                    active={1 === currentPage}
                    className={1 === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={1 === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(1);
                        }}
                    >
                        {1}
                    </PagerLink>
                </PagerItem>
            );
            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );
        }

        for (let i =  startInd  ; i <= endInd  ; i++) {


            pages.push(
                <PagerItem
                    key={i}
                    active={i === currentPage}
                    className={i === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={i === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(i);
                        }}
                    >
                        {i}
                    </PagerLink>
                </PagerItem>
            );


        }

        if(currentPage < totalPages-2){

            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );

            pages.push(
                <PagerItem
                    key={totalPages}
                    active={totalPages === currentPage}
                    className={totalPages === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={totalPages === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(totalPages);
                        }}
                    >
                        {totalPages}
                    </PagerLink>
                </PagerItem>
            );
        }
        return (
            <Pager className="mt-3 justify-content-center" aria-label="Navigazione elenco persone">
                <PagerItem disabled={currentPage === 1}>
                    <PagerLink
                        previous
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                        }}
                    >
                        <Icon icon="it-chevron-left" />
                    </PagerLink>
                </PagerItem>

                {pages}

                <PagerItem disabled={currentPage === totalPages}>
                    <PagerLink
                        next
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                        }}
                    >
                        <Icon icon="it-chevron-right" />
                    </PagerLink>
                </PagerItem>
            </Pager>
        );
    };

    return (
        <Container className="bg-white py-3 py-lg-6">
            {/* Card parametri di ricerca */}

            <div style={{display:"flex"}}>
                <div style={{flex:1}}>
                    <h2 className="mb-5 ">Elenco Persone</h2>
                </div>


                <div style={{flex:1}} align={"right"}>

                </div>

            </div>

            <Row className="mb-4">

                <Col md={1}>
                    <Label htmlFor="limit-select" className="mt-3"><strong>Righe per pagina:</strong>
                    </Label>
                </Col>
                <Col md={1}>
                    <select
                        id="limit-select"
                        value={limit}
                        onChange={(e) => handleLimitChange(Number(e.target.value))}
                        className="form-select m-3"
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </select>
                </Col>
                <Col md={10} className={"text-end"}>
                    <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                            navigate('/private/ricercaPersone')
                        }}
                    >
                        Nuova ricerca
                    </button>

                    <button
                        className="btn btn-outline-primary"
                        style={{marginLeft: "30px"}}
                        onClick={handleDownloadCsv}
                        disabled={isDownloading}
                    >
                        {isDownloading ? <Spinner active small /> : "Download Csv"}
                    </button>
                </Col>

            </Row>

            <Row className="mb-4">

                <Col md={12}>

                    {alert.visible && (
                        <Alert color={alert.type} isOpen={alert.visible}
                               toggle={() => setAlert({...alert, visible: false})}>
                            {alert.message}
                        </Alert>
                    )}

                    {persone.length > 0 && (
                        <>
                            <Row className="mt-2">
                                <Col className="text-end">
                                    <small className="text-muted">
                                        Visualizzati
                                        da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                                    </small>
                                </Col>
                            </Row>
                            {totalPages > 1 && renderPagination()}
                        </>
                    )}

                    <div style={styles.tableContainer}>

                        <Table hover className="border-0">
                            <thead>
                            <tr>
                                <th scope="col" className="text-center" style={{display: "none"}}>#</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}
                                    onClick={() => handleSort("nome")}>
                                    NOME{" "}
                                    {sortField === "nome" ?
                                        <Icon color={"white"}
                                              icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                        :
                                        <Icon color={"white"} icon={"it-minus"}/>
                                    }
                                </th>
                                <th scope="col" className="text-center" style={styles.tableHeader}
                                    onClick={() => handleSort("cognome")}>
                                    Cognome{" "}
                                    {sortField === "cognome" ?
                                        <Icon color={"white"}
                                              icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                        :
                                        <Icon color={"white"} icon={"it-minus"}/>
                                    }
                                </th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Codice Fiscale</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Ruolo</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Area</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Profilo</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Modifica</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Elimina</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white">
                            {persone.length > 0 ? (
                                persone.map((persona, index) => (
                                    <tr key={index}>
                                        <td scope="row" className="text-center"
                                            style={{display: "none"}}>{offset + index + 1}</td>
                                        <td className="text-center" style={styles.tableRowText}>{persona.nome}</td>
                                        <td className="text-center" style={styles.tableRowText}>{persona.cognome}</td>
                                        <td className="text-center"
                                            style={styles.tableRowText}>{persona.codiceFiscale || '-'}</td>
                                        <td className="text-center"
                                            style={styles.tableRowText}>{persona.ruolo || '-'}</td>
                                        <td className="text-center"
                                            style={styles.tableRowText}>{persona.area || '-'}</td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-search"
                                                                              onClick={() => handleSearch(persona)}/>
                                        </td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-pencil" color="primary"
                                                                              onClick={() => handleEdit(persona.id)}/>
                                        </td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-delete" color="danger"
                                                                              onClick={() => openDeleteConfirm(persona)}/>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" style={styles.tableRowText} colSpan="8">
                                        Nessun risultato trovato
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>

                    </div>



                        {persone.length > 0 && (
                            <>
                                <Row className="mt-2">
                                    <Col className="text-end">
                                        <small className="text-muted">
                                            Visualizzati
                                            da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                                        </small>
                                    </Col>
                                </Row>
                                {totalPages > 1 && renderPagination()}
                            </>
                        )}

                </Col>


            </Row>

            {/* Tabella risultati */}
            <Row className="justify-content-center">

            </Row>

            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div toggle={closeDeleteConfirm}>Conferma Eliminazione</div>
                <div>
                    Sei sicuro di voler eliminare la persona: <strong>{personaToDelete?.nome} {personaToDelete?.cognome}</strong>?
                    <br />
                    L'azione non potrà essere annullata.
                </div>
                <div>
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    &nbsp;
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>
        </Container>
    );
};

export default ElencoPersone;
